module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "buildings"
    }
  }, [_c('el-row', {
    staticClass: "headLine"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v("产业空间信息（存量商务楼宇）")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "90px"
    },
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.goInner
    }
  }, [_vm._v("新建")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "90px"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.reList
    }
  }, [_vm._v("刷新")])], 1)], 1), _vm._v(" "), _c('BuildingList', {
    ref: "buildingList"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-e72ec4da"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/industryInfos/buildingManage/index.vue
// module id = 1579
// module chunks = 1